import React from 'react';
import ButtonAction from '../../Buttons/ButtonAction';
import './CommunityLayerList.scss';
import * as ROUTES from '../../../routes/'; 

function CommunityList(props) {
  return (
    <div className="CommunityLayerList" >
      <section /* className="CommunityList" */>
        <div className="communityLayer-wrapper">
          <div className="ListLayerImage">
            <img src="./img/Landing/community/img.png" alt="" />
          </div>
          <div className="ListLayerDescription">
            <img src="./img/Landing/community/b.svg" alt="Despachos de Abogados en México" />
            <p>
              Conoce a los abogados y despachos que ya obtienen clientes por medio
              de nuestra plataforma.
          </p>
            <ButtonAction direction={ROUTES.SEARCH_LAWYER + 'Abogados'} variant="secondary">Lista de abogados</ButtonAction>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CommunityList;
